import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'capitalizeFirstLetter',
})
export class CapitalizeFirstLetterPipe implements PipeTransform {
  transform(value: string): string {
    return `${value.substring(0, 1).toLocaleUpperCase()}${value.substring(1)}`;
  }
}
